import { InitialState } from './types'
import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'

const initialState: InitialState = {
  page: {
    created_at: '',
    module_id: '',
    position: 0,
    title: '',
    available_at: '',
  },
  screens: [],
  isFetching: false,
  isFetchingScreens: false,
  isProcessSave: false,
  isProcessRemove: false,
  isProcessCreateScreen: false,
  isProcessEditScreen: false,
  isProcessRemoveScreen: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchModule]: state => {
      return {
        ...state,
        isFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchModuleSuccess]: (state, action) => {
      return {
        ...state,
        page: action.result,
        isFetching: false,
      }
    },
    [actions.fetchModuleFailure]: (state, action) => {
      return {
        ...state,
        isFetching: false,
        error: action.error,
      }
    },
    [actions.fetchModuleScreens]: state => {
      return {
        ...state,
        isFetchingScreens: true,
      }
    },
    [actions.fetchModuleScreensSuccess]: (state, action) => {
      return {
        ...state,
        screens: action.result,
        isFetchingScreens: false,
      }
    },
    [actions.fetchModuleScreensFailure]: (state, action) => {
      return {
        ...state,
        isFetchingScreens: false,
        error: action.error,
      }
    },
    [actions.editModule]: state => {
      return {
        ...state,
        isProcessSave: true,
      }
    },
    [actions.editModuleSuccess]: state => {
      return {
        ...state,
        isProcessSave: false,
      }
    },
    [actions.editModuleFailure]: (state, action) => {
      return {
        ...state,
        isProcessSave: false,
        error: action.error,
      }
    },
    [actions.removeModule]: state => {
      return {
        ...state,
        isProcessRemove: true,
      }
    },
    [actions.removeModuleSuccess]: state => {
      return {
        ...state,
        isProcessRemove: false,
      }
    },
    [actions.removeModuleFailure]: (state, action) => {
      return {
        ...state,
        isProcessRemove: false,
        error: action.error,
      }
    },
    [actions.createScreen]: state => {
      return {
        ...state,
        isProcessCreateScreen: true,
        error: initialState.error,
      }
    },
    [actions.createScreenSuccess]: state => {
      return {
        ...state,
        isProcessCreateScreen: false,
      }
    },
    [actions.createScreenFailure]: (state, action) => {
      return {
        ...state,
        isProcessCreateScreen: false,
        error: action.error,
      }
    },
    [actions.editScreen]: state => {
      return {
        ...state,
        isProcessEditScreen: true,
        error: initialState.error,
      }
    },
    [actions.editScreenSuccess]: state => {
      return {
        ...state,
        isProcessEditScreen: false,
      }
    },
    [actions.editScreenFailure]: (state, action) => {
      return {
        ...state,
        isProcessEditScreen: false,
        error: action.error,
      }
    },
    [actions.removeScreen]: state => {
      return {
        ...state,
        isProcessRemoveScreen: true,
        error: initialState.error,
      }
    },
    [actions.removeScreenSuccess]: state => {
      return {
        ...state,
        isProcessRemoveScreen: false,
      }
    },
    [actions.removeScreenFailure]: (state, action) => {
      return {
        ...state,
        isProcessRemoveScreen: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
